export const LOCAL_PINCODE = "277123";
export const LOCAL_DELIVERY_CHARGE = 49;
export const REMOTE_DELIVERY_CHARGE = 300;

export const DELIVERY_PINCODE_KEY = "petal_delivery_pincode";

export function normalizePincode(pincode) {
  return String(pincode || "").replace(/\D/g, "").slice(0, 6);
}

export function isValidPincode(pincode) {
  return normalizePincode(pincode).length === 6;
}

export function isLocalPincode(pincode) {
  return normalizePincode(pincode) === LOCAL_PINCODE;
}

export function getDeliveryCharge(pincode) {
  if (!isValidPincode(pincode)) return null;
  return isLocalPincode(pincode) ? LOCAL_DELIVERY_CHARGE : REMOTE_DELIVERY_CHARGE;
}

export function getDeliveryLabel(pincode) {
  if (!isValidPincode(pincode)) return null;
  return isLocalPincode(pincode) ? "Local delivery" : "Outside local area";
}

export function saveDeliveryPincode(pincode) {
  try {
    sessionStorage.setItem(DELIVERY_PINCODE_KEY, normalizePincode(pincode));
  } catch {
    // ignore storage errors
  }
}

export function loadDeliveryPincode() {
  try {
    return sessionStorage.getItem(DELIVERY_PINCODE_KEY) || "";
  } catch {
    return "";
  }
}
